export default "<style>\n  string--field\n  {\n\n  }\n  \n\n</style>";